export default __webpack_public_path__ + "static/productosdelujo-ceo-7480b98f5ab88349ad403f4d34195709.jpeg";